export default __webpack_public_path__ + "static/media/6.79861a0a.svg";